<main class="executive-analytics" aria-labelledby="executive-analytics-title">
  <div class="container_dashboard executive-analytics__container">
    <header class="executive-analytics__heading">
      <h1 id="executive-analytics-title">DTFS Customer Portal | Executive Analytics</h1>
      <p>Digital adoption, transaction activity and customer self-service</p>
    </header>

    @if (loadError) {
      <div class="executive-analytics__error" role="alert">
        <p>{{ loadError }}</p>
        <button type="button" class="mbfs-button" (click)="loadAnalytics()">Retry</button>
      </div>
    }

    <section class="executive-analytics__metrics" aria-label="Portal summary" [attr.aria-busy]="isLoading">
      @for (metric of metrics; track metric.label) {
        <dl class="executive-analytics__metric">
          <dt>{{ metric.label }}</dt>
          <dd>{{ metric.value }}</dd>
        </dl>
      }
    </section>

    <div class="executive-analytics__charts">
      <section class="executive-analytics__panel" aria-labelledby="payments-title">
        <h2 id="payments-title">Payments by Type</h2>
        @for (payment of payments; track payment.label) {
          <div class="executive-analytics__chart-row">
            <p><strong>{{ payment.label }}</strong> {{ payment.value }}</p>
            <div class="executive-analytics__track" aria-hidden="true">
              <span class="executive-analytics__bar" [style.width.%]="payment.width"></span>
            </div>
          </div>
        }
      </section>

      <section class="executive-analytics__panel executive-analytics__assets" aria-labelledby="assets-title">
        <h2 id="assets-title">Assets by Account</h2>
        @for (asset of assets; track asset.label) {
          <div class="executive-analytics__chart-row">
            <p><strong>{{ asset.label }}</strong> {{ asset.percentage }}%</p>
            <div class="executive-analytics__track" aria-hidden="true">
              <span class="executive-analytics__bar" [style.width.%]="asset.percentage"></span>
            </div>
          </div>
        }
      </section>
    </div>

    <section class="executive-analytics__panel executive-analytics__self-service" aria-labelledby="self-service-title">
      <h2 id="self-service-title">Customer Self-Service</h2>
      <ul>
        @for (service of selfService; track service.label) {
          <li><strong>{{ service.label }}:</strong> {{ service.value }}</li>
        }
      </ul>
    </section>
  </div>
</main>
